function emptyResultForRequest(request) {
    return {
        hits: [],
        nbHits: 0,
        page: Number(request && request.params && request.params.page) || 0,
        nbPages: 0,
        hitsPerPage: Number(request && request.params && request.params.hitsPerPage) || 0,
        processingTimeMS: 0,
        query: (request && request.params && request.params.query) || "",
        params: "",
    };
}

function isTransientTypesenseError(error) {
    return (
        error &&
        (error.httpStatus === 0 || error.status === 0 || /HTTP code 0/i.test(error.message || ""))
    );
}

export function emptySearchResponse(requests) {
    return { results: (requests || []).map(emptyResultForRequest) };
}

export function createSafeTypesenseSearchClient(typesenseInstantsearchAdapter, { onError, onSuccess } = {}) {
    const searchClient = typesenseInstantsearchAdapter.searchClient;
    let sequence = 0;

    return {
        ...searchClient,
        search(requests) {
            const current = ++sequence;
            return searchClient.search(requests).then((result) => {
                if (current === sequence && onSuccess) onSuccess(result, requests);
                return result;
            }).catch((error) => {
                if (current === sequence && onError) onError(error);
                // Keep InstantSearch controls mounted on a resolver error. The
                // onError state hides hits/counts and presents the explicit error.
                if (!isTransientTypesenseError(error) && !error?.searchMessage) {
                    throw error;
                }

                console.warn("Typesense search temporarily unavailable", error);
                return {
                    results: (requests || []).map(emptyResultForRequest),
                };
            });
        },
    };
}
